import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import moment from "moment";
import { Grid, AutoSizer, CellMeasurerCache } from "react-virtualized";
import styles from "components/manage-envelopes/manage-envelopes.scss";
import { envelopeType } from "custom-prop-types";
import { Button } from "components/common/button";
import { RequestEnvelopeModal } from "components/manage-envelopes/request-envelope-modal";
import { SendEnvelopeModal } from "components/manage-envelopes/send-envelope-modal";
import { NoEnvelopes } from "components/manage-envelopes/no-envelopes";
import { CellRenderer, getGridHeight } from "components/grid/grid-components";

export const ManageEnvelopes = (props) => {
  let envelopes = props.envelopes;
  if (props.isAwaitingMailin) {
    envelopes = R.filter(
      (envelope) => moment(envelope.received).isValid() && envelope.uploaded === null,
      props.envelopes
    );
  }
  const columns = getColumns(props.isAwaitingMailin);
  return (
    <div className={ styles.container }>
      <div className={ styles.title }>
        <h1>{ props.title }</h1>
        <div className={ styles["envelope-actions"] }>
          <Button onClick={ props.onShowSendEnvelope }>Send your own envelope</Button>
          <Button onClick={ props.onShowRequestEnvelope } primary>Request a magic envelope</Button>
        </div>
      </div>
      <div>
        <AutoSizer disableHeight>
          {({ width }) => (
            <Grid
              { ...props }
              cache={ cache }
              cellRenderer={ ({ ...gridProps }) => <CellRenderer { ...gridProps } newKey={ gridProps.key } /> }
              className={ styles.grid }
              columnCount={ columns.length }
              columns={ columns }
              columnWidth={ width / columns.length }
              documents={ envelopes }
              fixedColumnCount={ 1 }
              fixedRowCount={ 1 }
              height={ getGridHeight(-1, envelopes.length, 45) }
              isRowFocusable={ false }
              isSelectable={ false }
              noContentRenderer={ () => <NoEnvelopes /> }
              rowCount={ envelopes.length + 1 }
              rowHeight={ 45 }
              selectedDocumentIds={ [] }
              width={ width }
            />
          )}
        </AutoSizer>
      </div>
      <RequestEnvelopeModal
        accountId={ props.accountId }
        isRequestEnvelopeVisible={ props.isRequestEnvelopeVisible }
        onHideRequestEnvelope={ props.onHideRequestEnvelope }
        onRequestEnvelope={ props.onRequestEnvelope }
      />
      <SendEnvelopeModal
        coversheetUrl={ props.coversheetUrl }
        isSendEnvelopeVisible={ props.isSendEnvelopeVisible }
        onHideSendEnvelope={ props.onHideSendEnvelope }
      />
    </div>
  );
};

ManageEnvelopes.propTypes = {
  accountId: PropTypes.string.isRequired,
  coversheetUrl: PropTypes.string.isRequired,
  envelopes: PropTypes.arrayOf(envelopeType).isRequired,
  isAwaitingMailin: PropTypes.bool.isRequired,
  isRequestEnvelopeVisible: PropTypes.bool.isRequired,
  isSendEnvelopeVisible: PropTypes.bool.isRequired,
  onHideRequestEnvelope: PropTypes.func.isRequired,
  onHideSendEnvelope: PropTypes.func.isRequired,
  onRequestEnvelope: PropTypes.func.isRequired,
  onShowRequestEnvelope: PropTypes.func.isRequired,
  onShowSendEnvelope: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

const getColumns = (isAwaitingMailin) => {
  if (isAwaitingMailin) {
    return ([
      {
        key: "code",
        name: "Envelope Code",
        visible: true
      },
      {
        key: "received",
        name: "Envelope Received",
        visible: true
      },
      {
        key: "billable",
        name: "Billable Envelope",
        visible: true
      }
    ]);
  }
  return ([
    {
      key: "code",
      name: "Envelope Code",
      visible: true
    },
    {
      key: "envelopeUploaded",
      name: "Uploaded",
      visible: true
    },
    {
      key: "received",
      name: "Envelope Received",
      visible: true
    },
    {
      key: "sent",
      name: "Envelope Sent",
      visible: true
    },
    {
      key: "status",
      name: "Envelope Status",
      visible: true
    }
  ]);
};

const cache = new CellMeasurerCache({
  defaultWidth: 75,
  minWidth: 75,
  fixedHeight: true
});



// WEBPACK FOOTER //
// ./src/js/components/manage-envelopes/manage-envelopes.jsx